import React, { useRef } from 'react'
import { press } from '../data/record'

// Press about the film. On a desktop these scroll sideways, like the laurels
// on the home page; on a phone they stack, and each card is shorter than the
// ones on the Climate Resilience page.

const PressCarousel = () => {
  const rail = useRef(null)

  const nudge = (dir) => {
    const el = rail.current
    if (!el) return
    el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: 'smooth' })
  }

  return (
    <div className='press-shell'>
      <button className='press-arrow press-arrow--prev' onClick={() => nudge(-1)} aria-label='Previous'>
        <svg viewBox='0 0 24 24' aria-hidden='true'>
          <polyline points='15,4 7,12 15,20' fill='none' stroke='currentColor' strokeWidth='1.5' />
        </svg>
      </button>

      <ul className='press-rail' ref={rail}>
        {press.map((item) => (
          <li className='press-card' key={item.url}>
            <a className='press-card-image' href={item.url} target='_blank' rel='noopener noreferrer' tabIndex={-1}>
              <img src={item.image} alt={item.alt} loading='lazy' />
            </a>
            <div className='press-card-body'>
              <p className='press-card-source'>{item.outlet}<span className='press-card-dot'>·</span>{item.date}</p>
              <h3 className='press-card-title'>{item.headline}</h3>
              <span className='press-card-rule' aria-hidden='true' />
              <p className='press-card-text'>{item.note}</p>
              <p className='press-card-link'>
                <a className='link-button' href={item.url} target='_blank' rel='noopener noreferrer'>Read it</a>
              </p>
            </div>
          </li>
        ))}
      </ul>

      <button className='press-arrow press-arrow--next' onClick={() => nudge(1)} aria-label='Next'>
        <svg viewBox='0 0 24 24' aria-hidden='true'>
          <polyline points='9,4 17,12 9,20' fill='none' stroke='currentColor' strokeWidth='1.5' />
        </svg>
      </button>
    </div>
  )
}

export default PressCarousel
